import { DEFAULT_BUILDERS_PROJECTS_DATA } from '../../constants/buildersProjectsData';
import { ResponseError } from '../../errors';
import { prepareBuildersProjectsData } from '../../mappers/prepareBuildersProjectsData';
import {
  IGetProjectsListRequest,
  TGetProjectsListResponse,
  fetchGetProjectsList,
} from '../../repositories/countryside-constructors/v1/get-projects-list';
import { IApplicationContext } from '../../types/applicationContext';
import { IBuildersProjectsData } from '../../types/buildersProjects';

export async function fetchBuildersProjectsData(
  { httpApi, logger }: IApplicationContext,
  parameters: IGetProjectsListRequest,
): Promise<IBuildersProjectsData> {
  try {
    const projectsData: TGetProjectsListResponse = await fetchGetProjectsList({
      httpApi,
      parameters,
    });

    if (projectsData.statusCode !== 200) {
      throw new ResponseError({
        domain: 'fetchBuildersProjectsList',
        message: projectsData.response.message || '',
        details: {
          errors: JSON.stringify(projectsData.response.errors),
        },
      });
    }

    return prepareBuildersProjectsData(projectsData.response);
  } catch (error) {
    logger.warning(error);

    return DEFAULT_BUILDERS_PROJECTS_DATA;
  }
}
